export default __webpack_public_path__ + "static/media/Icon14.3c09a134.svg";